import { Navigate } from 'react-router-dom';
import { UserStateContext } from '../Context/AuthContext';

const ProtectedRoute = ({ element, allowedRoles, allowedRoleIds, excludedRoles, excludedRoleIds, redirectTo = "/not-found" }) => {
  const { roleName, userRole: roleId, isAuthReady } = UserStateContext();

  if (!isAuthReady) {
    return null;
  }

  // If both roleId and roleName are empty, authentication data is corrupted or missing
  if (!roleId && !roleName) {
    // Clear all potentially corrupted auth data
    localStorage.removeItem('role');
    localStorage.removeItem('userRole');
    localStorage.removeItem('roleDecrypted');
    localStorage.removeItem('userRoleDecrypted');
    localStorage.removeItem('token');
    return <Navigate to="/login" replace />;
  }

  // Check excludedRoleIds first (for role IDs like "1", "2", etc.)
  if (excludedRoleIds && roleId && excludedRoleIds.includes(roleId)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Check excludedRoles (for role names like "admin", "5", "viewonly")
  if (excludedRoles && roleName && excludedRoles.includes(roleName)) {
    return <Navigate to={redirectTo} replace />;
  }

  // Check allowedRoleIds (for role IDs)
  if (allowedRoleIds && (!roleId || !allowedRoleIds.includes(roleId))) {
    return <Navigate to={redirectTo} replace />;
  }

  // Check allowedRoles (for role names)
  if (allowedRoles && (!roleName || !allowedRoles.includes(roleName))) {
    return <Navigate to={redirectTo} replace />;
  }

  return element;
};

export default ProtectedRoute;
